<template>
    <div v-if="showModal">
        <b-modal
                v-model="showModalLocal"
                title="Настройки печати документа"
                class="modal-primary"
                size="md"
                ok-variant="primary"
                @hide.prevent
                @ok="handleOk"
                @cancel="handleCancel"
                @close="handleCancel"
                ref="my-modal"
        >

            <b-form-group>
                <b-form-checkbox-group stacked id="basicCustomCheckboxes">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="faximile" value="1" checked v-model="voucherx.faximile">
                        <label class="custom-control-label" for="faximile">Печать факсимиле</label>
                    </div>
                </b-form-checkbox-group>
            </b-form-group>

            <template slot="modal-footer" slot-scope="{ ok, cancel, close }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Отказаться
                </b-button>
                <b-button size="sm" variant="outline-success" @click="ok()">
                    Напечатать
                </b-button>
            </template>
        </b-modal>
    </div>
</template>


<script>
    import { functions } from '@/functions';
    import { functions_loaders } from '@/functions_loaders';
    import {CONSTANTS} from '@/constants'

    export default {
        name: 'PrintFaximileDialog',
        mixins: [functions, functions_loaders ],
        data: function () {
            return {

            };
        },
        model: {
            prop: "showModal",
            event: "hide",
        },
        props: {
            showModal: [Number, Boolean],
            voucherx: Object,
            mode: String
        },
        watch: {
        },
        methods: {
            handleCancel: function () {
                //console.log('SimpleDialog: handleCancel');
                this.$emit("hide", false);
            },
            handleOk: function () {
                //console.log('SimpleDialog: handleOk');
                this.$emit("print");
                this.$emit("hide", false);
            },
            handleSubmit: function () {
                //console.log('SimpleDialog: handleSubmit');
                this.$emit("print");
                this.$emit("hide", false);
            },
        },
        computed: {
            showModalLocal: {
                get: function () {
                    return this.showModal
                },
                set: function (newValue) {}
            },
            getInvoices: function() {
                let invoices = [
                    {id:0, title:'основной'}
                ];
                for (let i=0; i<this.guestsx.length;i++) {
                    let j = i+1;
                    let id = this.guestsx[i].invoice_subid;
                    invoices.push({id:j, title:'доп/'+id})
                }
                return invoices;
            }
        },
        created: function() {
        },
        mounted: function() {
            //console.log('SimpleDialog: mounted');
        },
        updated: function() {
            console.log('SimpleDialog: updated');

        },
    }
</script>